import { render, staticRenderFns } from "./CampaignButtonPublishers.vue?vue&type=template&id=5cdbb825&"
import script from "./CampaignButtonPublishers.vue?vue&type=script&lang=js&"
export * from "./CampaignButtonPublishers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports